import type { FC, ReactElement } from "react"

import { ETypographyColor, ETypographySize, Typography } from "@/3514/components"
import { withPressHandler } from "@/3514/utils"

import classes from "./session-info.styles"
import { type _TSessionInfoMessageComponentProps as TProps } from "./session-info.types"

const SessionInfoMessage: FC<TProps> = ({
    text,
    typeIcon,
    helpIcon,
    isAccessible,
    ariaLabel,
    action
}: TProps): ReactElement => (
    <div
        className={classes.body.messages.item({ isAccessible })}
        {...(isAccessible && {
            "aria-label": ariaLabel,
            tabIndex: 0,
            role: "button",
            onClick: withPressHandler(action),
            onKeyDown: withPressHandler(action)
        })}
    >
        {typeIcon}

        <Typography text={text} size={ETypographySize.Small} color={ETypographyColor.Black} />

        {helpIcon}
    </div>
)

SessionInfoMessage.displayName = "SessionInfoMessage"

export default SessionInfoMessage
